/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs */

const es_user_profile_api_keys_toasts_generate_success_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asegurate de copiarla y guardarla de forma segura.`)
};

const en_user_profile_api_keys_toasts_generate_success_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make sure to copy and store it securely.`)
};

/**
* | output |
* | --- |
* | "Make sure to copy and store it securely." |
*
* @param {User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_generate_success_description = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Generate_Success_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_generate_success_description(inputs)
	return en_user_profile_api_keys_toasts_generate_success_description(inputs)
});
export { user_profile_api_keys_toasts_generate_success_description as "user.profile.api_keys.toasts.generate.success_description" }